import React, { useState } from "react";
import { Container, Card, Row, Col, Button } from "react-bootstrap";

const OtherServicesCarousel = () => {
  const services = [
  
    { image: "/assets/img/customflyers.jpg", title: "Custom flyers Printing Serives" , link: "/custom-flyers-printing-services" },
    { image: "/assets/img/certificateprinting.jpg", title: "Certificate Printing Services" , link: "/certificate-printing-services" },
    { image: "/assets/img/businesscard.jpg", title: "Business Card Printing" , link: "/business-card-printing" },
    { image: "/assets/img/schoolcopy.jpg", title: "School Copy Printing" , link: "/school-copy-printing" },
    { image: "/assets/img/presentationprint.jpg", title: "Presentation Printing" , link: "/presentation-printing" },
    { image: "/assets/img/professionalprints.jpg", title: "Printing of Bags" , link: "/printing-of-bags" },
    { image: "/assets/img/indoorbanner.jpg", title: "Indoor Banners" , link: "/indoor-banners" },
    { image: "/assets/img/stationaryprints.jpg", title: "Stationary Banners" , link: "/printing-of-stationary-banners" },
    { image: "/assets/img/flagprinting.jpg", title: "Printing of Flags" , link: "/printing-of-flags" },
    { image: "/assets/img/tablsigns.jpg", title: "Table Signs" , link: "/printing-table-signs" },
    { image: "/assets/img/backlitposters.jpg", title: "Backlit Posters" , link: "/printing-backlit-posters" },
    { image: "/assets/img/announcements.jpg", title: "Announcements" , link: "/printing-of-announcements" },
    { image: "/assets/img/blueprints.jpg", title: "Printing Blueprints" , link: "/printing-blueprints" },
    { image: "/assets/img/carmagnets.jpg", title: "Car Magnets" , link: "/car-magnets" },
    { image: "/assets/img/fabricbackdrop.jpg", title: "Printing of Fabric Backdrops" , link: "/printing-of-fabric-backdrops" },
    { image: "/assets/img/menuprinting.jpg", title: "Printing of Menus" , link: "/printing-of-menu" },
    { image: "/assets/img/aecprinting.jpg", title: "Ace Prints" , link: "/architecture-construction-and-engineering-prints" },
    { image: "/assets/img/customenvelops.jpg", title: "Custom Envelops" , link: "/custom-envelops" },
    { image: "/assets/img/notepads.jpg", title: "Custom Notepads" , link: "/custom-notepads" },
    { image: "/assets/img/stamps.jpg", title: "Stamps and Embossers" , link: "/stamps-and-embossers" },
    { image: "/assets/img/bindingdocs.jpg", title: "Document Printing & Binding" , link: "/document-printing-and-binding" },
    { image: "/assets/img/rackcards.jpg", title: "Rack Card Design" , link: "/rack-card-design" },
    { image: "/assets/img/hangtagprints.jpg", title: "Printing of Hangtags" , link: "/printing-of-hangtags" },
    { image: "/assets/img/windowgraphics.jpg", title: "Window Graphics" , link: "/window-graphics" },
    { image: "/assets/img/bannersign.jpg", title: "Banners Signs & Posters" , link: "/banners-signs-and-posters" },
    { image: "/assets/img/postitnotes.jpg", title: "Printing of Post It Notes" , link: "/printing-of-post-it-notes" },
    { image: "/assets/img/tablethrows.jpg", title: "Printing of Fabric Table Throws" , link: "/printing-of-fabric-table-throws" },
    { image: "/assets/img/fabricbannerss.jpg", title: "Fabric Banners" , link: "/printing-of-fabric-banners" },
    { image: "/assets/img/outdoorbanners.jpg", title: "Outdoors Banners" , link: "/outdoor-banners" },
    { image: "/assets/img/tabletopbanners.jpg", title: "Table Top Banners" , link: "/printing-table-top-banners" },
    { image: "/assets/img/seggraphics.jpg", title: "Seg Graphics" , link: "/seg-graphics-printing" },
    { image: "/assets/img/signboards.jpg", title: "Signboards Printing" , link: "/printing-signboards" },
    { image: "/assets/img/posterprints.jpg", title: "Poster Prints" , link: "/poster-prints" },
    { image: "/assets/img/doorhanger.jpg", title: "Door Hanger Printing" , link: "/door-hanger-printing" },
    { image: "/assets/img/notecards.jpg", title: "Custom Note Cards" , link: "/custom-note-cards" },
    { image: "/assets/img/pocketfolders.jpg", title: "Custom Pocket Folder" , link: "/custom-pocket-folder" },
    { image: "/assets/img/postcards.jpg", title: "Postcard Printing & Designing" , link: "/postcard-printing-and-designing" },
    { image: "/assets/img/stickersprints.jpg", title: "Stickers and Labels" , link: "/printing-of-stickers-and-labels" },
    { image: "/assets/img/flutterflags.jpg", title: "Flutter Flags" , link: "/printing-of-flutter-flags" },
    { image: "/assets/img/tripodbanners.jpg", title: "Large Tripod Banners" , link: "/large-tripod-banners" },
    { image: "/assets/img/retractablebanners.jpg", title: "Retractable Banners" , link: "/printing-of-retractable-banners" },
    { image: "/assets/img/corrugated.jpg", title: "Corrugated Plastic Sign" , link: "/printing-corrugated-plastic-signs" },
    { image: "/assets/img/tentcards.jpg", title: "Table Tent Card Printing" , link: "/table-tent-card-printing" },
    { image: "/assets/img/floorgraphics.jpg", title: "Floor Graphics" , link: "/floor-graphics" },
    { image: "/assets/img/wallgraphics.jpg", title: "Wall Graphics" , link: "/wall-graphics" },
    { image: "/assets/img/printedboxes.jpg", title: "Printing of Boxes" , link: "/printing-of-boxes" },
    { image: "/assets/img/styereneprints.jpg", title: "Styrene Signs" , link: "/sytrene-sign-printing" },
    { image: "/assets/img/photoposter.jpg", title: "Photo Posters" , link: "/photo-posters-printing" },
    { image: "/assets/img/greetingcards.jpg", title: "Greeting Cards" , link: "/printing-greeting-cards" },
    { image: "/assets/img/invitations.jpg", title: "Invitaions" , link: "/printing-invitations" },
    { image: "/assets/img/notecards.jpg", title: "NoteCards" , link: "/printing-of-notecards" },
    { image: "/assets/img/automotive.jpg", title: "Automotive" , link: "/automotive-printing" },
    { image: "/assets/img/education.jpg", title: "Education" , link: "/printing-for-education" },
    { image: "/assets/img/eventsandfest.jpg", title: "Events & Festivals" , link: "/events-and-festivals" },
    { image: "/assets/img/thankyoucards.jpg", title: "Thankyou Cards" , link: "/printing-thankyou-cards" },
    { image: "/assets/img/postcards.jpg", title: "Postcards" , link: "/printing-of-postcards" },
    { image: "/assets/img/realestateprinting.jpg", title: "RealEstate" , link: "/realestate-printing" },
    { image: "/assets/img/restaurantimg.jpg", title: "Restaurant" , link: "/restaurants-printing" },
    { image: "/assets/img/retailprints.jpg", title: "Retail" , link: "/retail-printing" },
    { image: "/assets/img/travelprinting.jpg", title: "Travel" , link: "/travel-printing" },
  ];

  const [showAll, setShowAll] = useState(false);

  const toggleShowAll = () => {
    setShowAll(!showAll);
  };

  return (
    <section className="other-services py-5 bg-light">
      <Container>
        <h2 className="text-center mb-4">Our Other Services</h2>
        <Row className="justify-content-center">
          {(showAll ? services : services.slice(0, 8)).map((service, idx) => {
            // Determine background color based on index
            const backgroundColor =
              idx % 2 === 0
                ? "linear-gradient(45deg, #e2f1ff, #caffce82)"
                : "linear-gradient(45deg, #fae2ff, #e3ffca82)";

            return (
              <Col lg={3} md={4} sm={6} key={idx} className="mb-4">
                <Card className="shadow-sm heighted" style={{ background: backgroundColor }}>
                  <a href={service.link} style={{ textDecoration: "none", color: "inherit" }}>
                    <Card.Img
                      variant="top"
                      src={service.image}
                      alt={service.title}
                      className="img-fluid"
                    />
                    <Card.Body>
                      <Card.Title className="text-center">
                        {service.title}
                      </Card.Title>
                    </Card.Body>
                  </a>
                </Card>
              </Col>
            );
          })}
        </Row>
        <div className="text-center mt-3">
          <Button variant="primary" onClick={toggleShowAll}>
            {showAll ? "Show Less" : "Show More"}
          </Button>
        </div>
      </Container>
    </section>
  );
};

export default OtherServicesCarousel;
